import { OrganismModel } from '../organism.model';

export class OrganismRequest {
  public organismoDTO: OrganismModel;
}
